import React from "react";
import './CoreProducts.css';
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from 'react-responsive-carousel';
import { Button, Collapse } from '@chakra-ui/react'
import { MinusIcon, AddIcon } from '@chakra-ui/icons'
// import phoneLaptop from '../../assets/img/vr-phone-laptop.png';
import phoneLaptop from '../../assets/img/br-phone-laptop.png';
import tabletImagen from '../../assets/img/tablet-imagen.png';
import carousel1 from '../../assets/img/carousel1.jpg';
import carousel2 from '../../assets/img/carousel2.jpg';
import carousel3 from '../../assets/img/carousel3.jpg';
import {renderThumbs, renderIndicators, renderArrowPrev, renderArrowNext} from '../../commons/carousel.js'
import { AnimationOnScroll } from 'react-animation-on-scroll';


export default class CoreProducts extends React.Component {

	constructor(props){
		super(props)
		this.state = {
			isBeyondRarityExpanded: false,
			isImagenExpanded:false,
			delay: 300
		}
	}

	componentDidMount(){
		let delay = window.innerWidth < 769?0:300;
		this.setState({delay:delay})
	}

	renderCarousel(){
		return <Carousel
					renderArrowPrev={renderArrowPrev}
					renderArrowNext={renderArrowNext}
					renderThumbs={renderThumbs}
					renderIndicator={renderIndicators}
					showStatus={false}>
				<div className="carousel-slide">
					<img className="carousel-product-image" src={carousel1} alt="" />
					<div className="carousel-product-legend">
						<p className="item-subhead">TRAIT WEIGHTS</p>
						<p className="quote-text">Creators can assign different levels of importance to different traits.</p>
						<p className="quote-text">In the African-themed TribeX example, lighter-skinned individuals are more rare in the collection.</p>
						<p className="quote-text">In traditional rarity tools that can't account for human sentiment, lighter-skinned individuals will automatically be valued higher based solely on their frequency and nothing else.</p>
					</div>
				</div>
				<div className="carousel-slide">
					<img className="carousel-product-image" src={carousel3} alt="" />
					<div className="carousel-product-legend">
						<p className="item-subhead">VIBE THEMES</p>
						<p className="quote-text">Creators can now create deeper value with coordinated elements in Vibe sets (Given elements of the same frequency, an NFT can be more valuable the more coordinated its elements are. )</p>
						<p className="quote-text">In the Wall St Moms NFT example below, if you have 2 or more of any the baby elements and outfits, the NFT qualifies for the "Baby Whisperer" Vibe.</p>
					</div>
				</div>
				<div className="carousel-slide">
					<img className="carousel-product-image" src={carousel2} alt="" />
					<div className="carousel-product-legend">
						<p className="item-subhead">UTILITY</p>
						<p className="quote-text">Creators will be able to assign a utility value, especially useful in Play to Earn games where the value of the elements isn't determined by how many exist, but rather it's usefulness within the game.</p>
						<p className="quote-text">In this Freaks N' Guilds example below, the "rarity" of low Health doesn't matter when considering the valuation of the NFT. Players will always pick the NFT with higher health rating over the token that has a rare health rating.</p>
					</div>
				</div>
			</Carousel>
	}

	render() {

		return (
		<div id="core-products" className="products-container">

			<AnimationOnScroll initiallyVisible={false} animateIn="fadeDown" animateOnce={true} delay={0}>
				<div className="section-briefing">
					<h1 className="section-title">CORE PRODUCTS</h1>
					<div className="briefing-text">
						<p>
							Proprietary in-house technology leveraging the blockchain, scaled for and offered to our customers and their projects.
						</p>
					</div>
				</div>
			</AnimationOnScroll>

			<AnimationOnScroll initiallyVisible={false} animateIn="fadeUp" animateOnce={true} delay={0}>
				<div className="section-row brown-gradient">
					<div className="section-text text-left">
						<AnimationOnScroll initiallyVisible={false} animateIn="fadeRight" animateOnce={true} delay={this.state.delay}>
							<div className="section-text-content beyond-rarity-text">
								<h1 className="showcase-title item-title">BEYOND RARITY</h1>
								<div className="showcase-text">
									<p className="item-subhead">REVOLUTIONARY NFT VALUATION</p>
									<p className="item-body showcase-dscription">With our ground-breaking Rarity Engine complete, we are currently integrating our pricing engine, which will enable you to assess NFT collections like never before.</p>
									<Button variant={this.state.isBeyondRarityExpanded?'outlineYellow':'outlineYellowAnimated'} leftIcon={this.state.isBeyondRarityExpanded?<MinusIcon />:<AddIcon />} onClick={()=>{this.setState({isBeyondRarityExpanded:!this.state.isBeyondRarityExpanded})}}>
										{this.state.isBeyondRarityExpanded?'SHOW LESS':'SHOW MORE'}
									</Button>
								</div>
							</div>
						</AnimationOnScroll>
					</div>
					<div className="section-image image-right">
						<AnimationOnScroll initiallyVisible={false} animateIn="fadeLeft" animateOnce={true} delay={this.state.delay}>
							<img className="beyond-img fade-to-black" src={phoneLaptop} alt=""/>
						</AnimationOnScroll>
					</div>
					<div className="section-accordion-container beyondrarity-accordion white-border">
						<Collapse in={this.state.isBeyondRarityExpanded} >
							<div className="expanded-accordion">
								<div className="rarity-text">
									<p className="item-subhead">VERSION 1.0 - REIMAGINING RARITY</p>
									<p className="item-body">Today's rarity tools rely on an old model of simple frequency statistics. Basically, if there's less of something, it's worth more.</p>
									<p className="item-body">NFT project creators and communities need more freedom to determine what's valuable in a collection, and more often than not, the frequency of something isn't sufficient.</p>
									<p className="item-body">Beyond Rarity allows founders the ability to adjust the values of the traits and features of their collection they believe to be most valuable. These controls consist of three categories: 1. Trait weights, 2. Vibes, and 3. Utility.</p>
								</div>
								{this.renderCarousel()}
							</div>
							<div className="expanded-accordion">
								<div className="rarity-text">
									<p className="item-subhead">VERSION 2.0 - RARITY VS. VALUATION</p>
									<p className="item-body">The centerpiece of BR2.0 is its commanding visual display of valuation vs rank for each and every NFT in a collection, all in one view. Know at a glance what is over / underpriced, and its deviation from expected.</p>
									<p className="item-body">It will integrate up-to-date pricing data with our ranking algorithm (as described above in the 1.0 section) to allow users to assess the rank of the NFT and quantitatively know with a confidence score what the buy/sell prices should be with decisions supported with data-based statistics.</p>
									<p className="item-body">The period of rampant NFT speculation is over. Users demand tools that will provide new ways to evaluate the fundamentals of the assets they are looking to invest in. Beyond Rarity is one of those tools that will be at the forefront of this revolution. </p>
								</div>
								<div>
									<div className="video-container">
										<iframe title="Beyond Rarity" src="https://player.vimeo.com/video/728492786?h=30365c2ed4" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>

									</div>
								</div>
							</div>
						</Collapse>
					</div>
				</div>
			</AnimationOnScroll>

			<AnimationOnScroll initiallyVisible={false} animateIn="fadeUp" animateOnce={true} delay={0}>
				<div className="section-row brown-gradient section-image-first">
					<div className="section-image image-left">
						<AnimationOnScroll initiallyVisible={false} animateIn="fadeRight" animateOnce={true} delay={this.state.delay}>
							<img className="imagen-img fade-to-black" src={tabletImagen} alt=""/>
						</AnimationOnScroll>
					</div>
					<div className="section-text text-right">
						<AnimationOnScroll initiallyVisible={false} animateIn="fadeLeft" animateOnce={true} delay={this.state.delay}>
							<div className="section-text-content">
								<h1 className="item-title">IMAGEN</h1>
								<div className="showcase-text" style={this.state.isImagenExpanded?{height:'100%'}:{height:'auto'}}>
									<p className="item-subhead">SOPHISTICATED NFT IMAGE GENERATION ENGINE</p>
									<p className="item-body showcase-description">More than slapping layers together, Imagen is built from the ground up to handle complex combinations of rules, connections and probabilities, for the NFT collection with discerning tastes.</p>
									<Button variant={this.state.isImagenExpanded?'outlineYellow':'outlineYellowAnimated'} leftIcon={this.state.isImagenExpanded?<MinusIcon />:<AddIcon />} onClick={()=>{this.setState({isImagenExpanded:!this.state.isImagenExpanded})}}>
										{this.state.isImagenExpanded?'SHOW LESS':'SHOW MORE'}
									</Button>
								</div>
							</div>
						</AnimationOnScroll>
					</div>
					<div className="section-accordion-container">
						<Collapse in={this.state.isImagenExpanded}>
							<div className="expanded-accordion divided-accordion">
								<div className="imagen-video mobile-white-border">
									<div className="video-container">
										<iframe title="Imagen Video" src="https://player.vimeo.com/video/723529953?h=15b99a710a&title=0&byline=0&portrait=0" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>
										<p style={{visibility: 'hidden'}}><a href="https://vimeo.com/723529953">Imagen - Intelligent Generative Art Engine</a> from <a href="https://vimeo.com/user153028191">WallStFam</a> on <a href="https://vimeo.com">Vimeo</a>.</p>
									</div>
								</div>
								<div className="imagen-expanded-text white-border">
									<p className="item-subhead">CHALLENGING REQUIREMENTS</p>
									<p className="item-body">The Wall St Fam collection posed several fundamental challenges that required a sophisticated program with logic to simultaneously handle complex combinations of rules, connections and probabilities</p>
									<p className="item-body">With 2000+ elements across 40+ layers, with independently grasping hands each holding a different object, gloves, hair, outfits, headgear, accessories, foregrounds/backgrounds, skintones and more to be truly interchangeable meant that spatially they must frequently exist on multiple layers.</p>
									<p className="item-body">For example, any given hairstyle can fall naturally in front and behind of the body. So the right parts must be layered and matched appropriately to avoid a mishmash of mixed up parts.</p>
									<p className="item-body">Multiply this scenario across almost every element means massive coordination and logic across dozens of corresponding layers to create a coherent figure.</p>
									<p className="item-body">Creators of an NFT collection can also define the probability of each elements' existence within the collection, determining its rarity.</p>
									<p className="item-body">So the engine coordinates all the complexities and visual logic above for each individual piece of art on a micro level while factoring creator-defined probabilities to control distribution of attributes throughout the entire set on a macro level.</p>
								</div>

							</div>
						</Collapse>
					</div>
				</div>
			</AnimationOnScroll>
		</div>
		);
	}
}
